module.exports = __webpack_public_path__ + "static/media/002-girl.fd5a4b79.svg";